<template>
  <div></div>
</template>
<script setup>
import { computed, onMounted, onBeforeUnmount, watch, nextTick, getCurrentInstance } from 'vue';

// 全局变量
let divMask = null;
let observer = null;
let container = null;
let src = '';

const config = {
  attributes: true,
  childList: true,
  subtree: true
};

const WATERMASK_ID = '__ecyWatermask';

// 获取组件实例
const instance = getCurrentInstance();

// Props定义
const props = defineProps({
  content: {
    type: String,
    default: 'watermask' // 水印文字
  },
  rotate: {
    type: Number,
    default: -20 // 旋转角度
  },
  width: {
    type: [Number, String],
    default: 320
  },
  height: {
    type: [Number, String],
    default: 200
  },
  fontSize: {
    type: Number,
    default: 14
  },
  fontFamily: {
    type: String,
    default: 'PingFang SC, sans-serif, Microsoft Yahei'
  },
  color: {
    type: String,
    default: 'rgba(156, 162, 169, 0.18)'
  },
  zIndex: {
    type: Number,
    default: 9999
  },
  transformX: {
    type: Number,
    default: 0
  },
  transformY: {
    type: Number,
    default: 50
  }
});

// 响应式数据 - 完全按照原版逻辑
const cssStyle = computed(
  () => `
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  position: fixed;
  z-index: ${props.zIndex};
  background-repeat: repeat, repeat;
  background-position: ${props.width / 2}px ${props.height / 2}px , 0 0;
`
);

// 方法定义 - 完全按照原版逻辑
const genWartermask = () => {
  const waterDiv = document.getElementById(WATERMASK_ID);
  if (waterDiv) {
    waterDiv.remove();
  }
  divMask = document.createElement('div');
  divMask.setAttribute('id', WATERMASK_ID);

  divMask.style.cssText = cssStyle.value;
  divMask.style.backgroundImage = drawSvgWatermask();
  appendContainer();
};

// deprecated canvas - 保持原版逻辑
const drawCanvasWatermask = () => {
  const canvas = document.createElement('canvas');
  const ratio = window.devicePixelRatio || 1;

  canvas.setAttribute('width', `${props.width * ratio}`);
  canvas.setAttribute('height', `${props.height * ratio}`);
  canvas.style.width = `${props.width}px`;
  canvas.style.height = `${props.height}px`;
  const ctx = canvas.getContext('2d');
  ctx.scale(ratio, ratio);
  ctx.clearRect(0, 0, props.width, props.height);
  ctx.textBaseline = 'top';
  ctx.textAlign = 'left';
  ctx.font = `${props.fontSize}px ${props.fontFamily}`;
  ctx.fillStyle = props.color;
  ctx.translate(props.transformX, props.transformY);
  ctx.rotate((props.rotate * Math.PI) / 180);
  ctx.translate(-props.transformX, -props.transformY - props.fontSize);
  ctx.fillText(
    props.content,
    props.transformX * ratio,
    (props.transformY + props.fontSize) * ratio
  );

  src = canvas.toDataURL('image/png');

  return `url(${src}),url(${src})`;
};

const drawSvgWatermask = () => {
  // 将换行符替换为SVG的tspan元素，实现多行显示
  const formattedContent = props.content
    .split('\n')
    .map((line, index) => `<tspan x="50%" dy="${index === 0 ? 0 : 1.2}em">${line}</tspan>`)
    .join('');

  const svgStr = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${props.width}" height="${props.height}">
      <text x="50%" y="50%" dy="12px"
        font-family="${props.fontFamily}"
        font-weight="200"
        text-anchor="middle"
        stroke="${props.color}"
        stroke-width="1"
        fill="none"
        transform="rotate(${props.rotate}, ${props.width} ${props.height})"
        style="font-size: ${props.fontSize};">
        ${formattedContent}
      </text>
    </svg>
  `;
  const base64Url = `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svgStr))
  )}`;
  return `url(${base64Url}),url(${base64Url})`;
};

const appendContainer = () => {
  if (divMask && container) {
    container.appendChild(divMask);
  }
};

const disconneted = () => {
  if (observer) {
    observer.disconnect();
  }
};

// 检测水印是否被修改或删除
const observerWatermask = () => {
  disconneted();
  observer = new MutationObserver(() => {
    const __wm = document.getElementById(WATERMASK_ID);
    if ((__wm && __wm.getAttribute('style') !== cssStyle.value) || !__wm) {
      observer.disconnect();
      observer = null;

      genWartermask();
      observerWatermask();
    }
  });
  observer.observe(container, config);
};

// 生命周期钩子 - 完全按照原版逻辑
onMounted(() => {
  container = instance?.proxy?.$el?.parentNode;
  nextTick(() => {
    genWartermask();
    observerWatermask();
  });
});

onBeforeUnmount(() => {
  disconneted();
  if (divMask) {
    divMask.remove();
  }
  divMask = null;
  observer = null;
  container = null;
  src = '';
});

// 监听content变化 - 完全按照原版逻辑
watch(
  () => props.content,
  (val) => {
    if (val) {
      genWartermask();
    }
  },
  { immediate: true }
);
</script>

<script>
// 定义组件名称 - Vue 3兼容方式
export default {
  name: 'EcyWatermark'
};
</script>
